<template>
  <div class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
      <h1>🚧 Maintenance Mode</h1>
      <p class="mt-3">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: 'Application is under maintenance',
    };
  },
  mounted() {
    const msg = localStorage.getItem('maintenance_message');
    if (msg) {
      this.message = msg;
    }
  },
};
</script>
